import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Intentaste afirmaciones positivas, pero no pueden borrar lo que está grabado en tus raíces.', 'Intentaste terapia tradicional, pero el problema no es solo mental, es una atadura del alma.', 'Intentaste ignorarlo, pero lo que no se sana en una generación, se repite con más fuerza en la siguiente.', 'Intentaste orar, pero hay puertas que no se abren hasta que no entregas la carga que no te pertenece.'];
  return <section className="pt-10 pb-10 px-4 bg-cream-light border-y border-gold/20" data-id="element-195">
      <div className="max-w-4xl mx-auto" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-197">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal font-bold mb-8 text-center" data-id="element-198">
            Hay un cansancio que no se quita durmiendo.
          </h2>

          <div className="space-y-6 text-lg text-charcoal-light leading-relaxed text-center max-w-2xl mx-auto" data-id="element-199">
            <p data-id="element-200">
              Es el cansancio de repetir historias. De esforzarte el doble para
              avanzar la mitad. De sentir que tienes un{' '}
              <strong className="text-charcoal font-serif italic" data-id="element-201">
                "techo invisible"
              </strong>{' '}
              sobre tu cabeza que bloquea tu provisión.
            </p>
            <p data-id="element-202">
              En nuestras familias hispanas, los silencios, los traumas y las
              carencias se filtran a través de la sangre. La Biblia lo llama
              iniquidad; la ciencia lo llama epigenética. Tú lo sientes como una
              "nube" que no te deja ver el sol, aunque sepas que Dios tiene
              grandes cosas para ti.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-10 shadow-sm border border-gold/20 relative mt-8" data-id="element-203">
          <div className="flex justify-center mb-6" data-id="element-204">
            <span className="bg-charcoal text-gold px-6 py-2 rounded-full text-sm font-bold tracking-widest uppercase" data-id="element-205">
              Por qué sigues estancada
            </span>
          </div>

          <h3 className="text-2xl font-serif text-charcoal font-bold mb-10 text-center" data-id="element-206">
            Lo que has intentado no funcionó porque atacaba las hojas, no la
            raíz.
          </h3>

          <ul className="space-y-5 max-w-2xl mx-auto" data-id="element-207">
            {failedAttempts.map((attempt, index) => {
            const commaIndex = attempt.indexOf(',');
            const boldPart = attempt.substring(0, commaIndex);
            const restPart = attempt.substring(commaIndex + 1).trim();
            return <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-start gap-4 bg-cream/60 p-4 rounded-sm border-l-4 border-red-400/50" data-id="element-208">
                  <XCircle className="text-red-400/70 shrink-0 mt-0.5" size={22} data-id="element-209" />
                  <p className="text-charcoal-light text-base leading-relaxed" data-id="element-210">
                    <span className="font-bold text-charcoal" data-id="element-211">{boldPart},</span>{' '}
                    {restPart}
                  </p>
                </motion.li>;
          })}
          </ul>
        </motion.div>
      </div>
    </section>;
}